import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { on } from '@ember/modifier';

import type RouterService from '@ember/routing/router-service';

interface SidebarSearchSignature {
  Args: {
    placeholder?: string;
  };
}

export default class SidebarSearchComponent extends Component<SidebarSearchSignature> {
  @service declare router: RouterService;

  @tracked searchQuery = '';

  get placeholder() {
    return this.args.placeholder || 'Search articles, teams, players...';
  }

  @action
  updateQuery(event: Event) {
    const target = event.target as HTMLInputElement;
    this.searchQuery = target.value;
  }

  @action
  handleSubmit(event: Event) {
    event.preventDefault();

    const query = this.searchQuery.trim();
    if (!query) return;

    // Navigate to search results
    this.router.transitionTo('search', {
      queryParams: { q: query },
    });

    // Clear the input
    this.searchQuery = '';
  }

  @action
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.handleSubmit(event);
    }
  }

  <template>
    <div class='widget-sidebar'>
      <form class='sidebar-search-form' {{on 'submit' this.handleSubmit}}>
        <div class='submit-input full blue'>
          <input
            type='text'
            id='sidebar-search1'
            name='sidebar-search1'
            placeholder={{this.placeholder}}
            value={{this.searchQuery}}
            {{on 'input' this.updateQuery}}
            {{on 'keydown' this.handleKeyDown}}
          />
          <button type='submit' class='submit-input-button'>
            <svg class='search-icon small'>
              <use href='#svg-search'></use>
            </svg>
          </button>
        </div>
      </form>
    </div>
  </template>
}
